import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import { vuetifyOptions } from '@ilteducation/themes/manabua/vuetifyOptions';

const vuetify = createVuetify(vuetifyOptions);

export default vuetify;
